import React from 'react';
/* Ciberseguridad */
import MenuLateralAntiSpoofing from '../../../../pages/cybersecurity/reports/estudio-antispoofing/MenuLateralAntiSpoofing';
import MenuLateralInvestigacionAtaquesDdos from '../../../../pages/cybersecurity/reports/investigacion-sobre-ataques-ddos/MenuLateralInvestigacionAtaquesDdos';
import MenuLateralAtaquesDdos from '../../../../pages/cybersecurity/reports/vulnerabilidad-ataques-ddos/MenuLateralAtaquesDdos'
/* Interconexion */
import MenuLateralConectividadEnLac from '../../../../pages/interconnection/reports/ContectividadEnLac/MenuLateralConectividadEnLac'
import MenuLateralConectividad2022 from '../../../../pages/interconnection/reports/analisis-caminos-del-trafico/MenuLateralConectividad2022';
import MenuLateralMejoresPracticasParaIXP from '../../../../pages/interconnection/reports/mejores-practicas-ixp/MenuLateralMejoresPracticasParaIXP';
import MenuLateralDNSOverTLS from '../../../../pages/interconnection/reports/DNSOverTLS/MenuLateralDNSOverTLS';
import MenuLateralInterconexionBgp from '../../../../pages/interconnection/reports/InterconexionBgp/MenuLateralInterconexionBgp'
import MenuLateralInterconexionBgpLocal from '../../../../pages/interconnection/reports/InterconexionBgpLocal/MenuLateralInterconexionBgpLocal';
import MenuLateralOptimizacionRedesBgp from '../../../../pages/interconnection/reports/OptimizacionRedesBgp/MenuLateralOptimizacionRedesBgp';
import MenuLateralRootServerLocal from '../../../../pages/interconnection/reports/UsoRootServerLAC/MenuLateralRootServerLocal';
/* IPv6 */
import SidebarSoporteIPv6EquiposCPEV1 from '../../../../pages/IPv6/sidebars/SidebarSoporteIPv6EquiposCPEV1'
/* Components */
import MainSidebar from '../main-sidebar/MainSidebar';
  
const sidebarComponents = { 
  /* interconexion  */
  'analisis-de-los-caminos-del-trafico-dentro-de-cada-pais-de-la-region-lac': MenuLateralConectividad2022,
  'conectividad-en-la-region-lac-2020': MenuLateralConectividadEnLac, 
  'mejores-practicas-para-ixp': MenuLateralMejoresPracticasParaIXP, 
  'uso-de-dns-over-tls-en-latinoamerica-y-el-caribe': MenuLateralDNSOverTLS,   
  'optimizacion-de-redes-mediante-un-mejor-ibgp': MenuLateralOptimizacionRedesBgp,  
  'interconexion-en-bgp-en-la-region-de-america-latina-y-el-caribe': MenuLateralInterconexionBgp,   
  'interconexion-bgp-a-nivel-local-en-la-region-de-americalatina-y-el-caribe': MenuLateralInterconexionBgpLocal, 
  'uso-de-root-servers-del-dns-en-la-region': MenuLateralRootServerLocal,  
  /* ciberseguridad */
  'estudio-de-recursos-de-internet-de-la-region-lac-que-posibilitan-ataques-de-ddos': MenuLateralAtaquesDdos,
  'estudio-anti-spoofing-en-la-region': MenuLateralAntiSpoofing,
  'investigacion-sobre-ataques-ddos': MenuLateralInvestigacionAtaquesDdos,  
  /* ipv6 */
  'informe-sobre-soporte-de-ipv6-en-equipos-cpe-version-1-2020': SidebarSoporteIPv6EquiposCPEV1, 
   
};


const ReportsSidebar = ({ menu_lateral, category, setSearchTerm, searchTerm, handleSearch, routes, lang }) => {
  // Si es un componente que necesita props adicionales
  if (menu_lateral === 'otrolink') {
    const SidebarComponent = sidebarComponents[menu_lateral];
    return (
      <SidebarComponent 
        menu_lateral={menu_lateral}
        setSearchTerm={setSearchTerm}
        searchTerm={searchTerm}
        handleSearch={handleSearch}
      />
    );
  }

  // Si es un componente regular del sidebar
  if (sidebarComponents[menu_lateral]) {
    const SidebarComponent = sidebarComponents[menu_lateral];
    return   <SidebarComponent /> 
  }

  // Si no coincide con ningún slug específico, mostrar el menú por defecto
  return <MainSidebar category={category} routes={routes} lang={lang} />;
};

export default ReportsSidebar;